import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { theme } from '@pfmam/pfmam';
import ProductsTable from './productsTable';
//import productTypes from '../../../data/productTypes.json';
import BarCharts from './barChart';
//import holdingsHistory from '../../../data/HoldingsHistory.json';
import config from '../../../config';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { barDetailsFormatter, removeNull } from '../../../utils/common';
// import { barDetailsFormatter } from '../../../utils/common';
import moment from 'moment';
import _ from 'lodash';

const TableWrapper = styled.div`
  margin-top: 24px;
  .ant-table {
    &.ant-table-middle {
      border-radius: 4px;
      background: ${theme.colors.white};
    }
    .ant-table-tbody {
      & > tr {
        &:hover {
          &.ant-table-row {
            background: linear-gradient(
                0deg,
                rgba(23, 54, 93, 0.07),
                rgba(23, 54, 93, 0.07)
              ),
              ${theme.colors.white};
          }
        }
        cursor: pointer;
        & > td:not(.ant-table-expanded-row .ant-table-cell) {
          vertical-align: middle;
          padding: 16px;
          border-bottom-color: ${theme.colors.grey_fossil};
          &.ant-table-column-sort {
            background: ${theme.colors.transparent};
          }
        }
      }
    }
    .ant-table-thead {
      & > tr {
        & > th {
          background: ${theme.colors.light_grey};
          font-family: 'Inter';
          padding: 0 16px;
          font-weight: normal;
          line-height: 20px;
          &:not(:last-child) {
            &:not(.ant-table-selection-column) {
              &:not(.ant-table-row-expand-icon-cell) {
                &:not([colspan]) {
                  &::before {
                    background-color: ${theme.colors.transparent};
                  }
                }
              }
            }
          }
        }
      }
    }
    &.ant-table.ant-table-middle {
      .ant-table-thead {
        .ant-table-column-sorters {
          padding: 0;
          .ant-table-column-sorter-inner .anticon {
            color: ${theme.colors.grey_stone};
          }
          .ant-table-column-sorter-up.active,
          .ant-table-column-sorter-down.active {
            color: ${theme.colors.black_sorted};
          }
        }
        .ant-table-column-sorter-inner {
          margin-top: 0;
        }
      }
      .ant-table-row-expand-icon-cell {
        vertical-align: middle;
      }
    }
    .sort-space-none {
      .ant-table-column-sorters {
        justify-content: flex-start;
      }
      .ant-table-column-title {
        flex: 0 0 auto;
      }
      &.flex-end {
        .ant-table-column-sorters {
          justify-content: flex-end;
        }
      }
    }
  }
  .ant-table-title {
    padding: 0 !important;
  }
  .table-primary {
    &:first-child {
      margin-bottom: 24px;
    }
  }
  .ant-table {
    &.ant-table-middle {
      .ant-table-tbody {
        .ant-table-wrapper {
          &:only-child {
            .ant-table {
              margin: -19px -16px;
            }
          }
        }
        .ant-table-container {
          .ant-table-tbody {
            .ant-table-row {
              .ant-table-cell {
                padding: 14px 16px;
                background-color: ${theme.colors.grey_faint};
              }
              &:hover {
                .ant-table-cell {
                  background-color: transparent;
                }
              }
            }
          }
        }
      }
    }
  }
`;

const InvestmentTypeComponent = ({
  InvTypeBarDetails,
  InvTypeBarDates,
  InvTypeHoldings,
  handleAction,
  isHistoricalHoldings = false,
}) => {
  const [barDetails, setbarDetails] = useState(null);
  const [InvestmentTypeHoldings, setInvestmentTypeHoldings] = useState(null);
  const [barDates, setbarDates] = useState(null);
  const selectedAccount = useSelector(
    (state) => state.accountProfileSlice.selectedAccount
  );

  useEffect(() => {
    setbarDetails(InvTypeBarDetails);
    setbarDates(InvTypeBarDates);
    setInvestmentTypeHoldings(InvTypeHoldings);
  }, [InvTypeBarDetails, InvTypeBarDates, InvTypeHoldings]);

  return (
    <>
      {!isHistoricalHoldings && barDetails !== null && barDates !== null && (
        <BarCharts details={barDetails} date={barDates} selected="Investment" />
      )}
      {InvestmentTypeHoldings !== null && (
        <TableWrapper>
          <ProductsTable
            data={InvestmentTypeHoldings}
            handleAction={handleAction}
            type="pending"
          />
        </TableWrapper>
      )}
    </>
  );
};

export default InvestmentTypeComponent;
